export default __webpack_public_path__ + "static/Hailey_Mobile-75c342943abbb33e191f88c68adde34b.jpg";